import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/solid/jobs-fill.svg'
import _imports_1 from '@/assets/icons/solid/document-fill.svg'


const _hoisted_1 = { class: "grid grid-cols-12 gap-2 xl:gap-y-0" }
const _hoisted_2 = { class: "col-span-11 xl:col-span-3" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "font-bold text-sm" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "•", -1)
const _hoisted_7 = { class: "text-sm italic ml-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold not-italic" }, "•", -1)
const _hoisted_9 = { class: "text-sm italic ml-1" }
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = {
  key: 0,
  class: "col-span-1 xl:hidden lg:col-span-0 relative w-full h-full"
}
const _hoisted_12 = { class: "col-span-4 lg:col-span-2 xl:col-span-1" }
const _hoisted_13 = { class: "col-span-4 lg:col-span-2 xl:col-span-2" }
const _hoisted_14 = { class: "col-span-4 lg:col-span-2 xl:col-span-1" }
const _hoisted_15 = { class: "col-span-4 lg:col-span-2 xl:col-span-1" }
const _hoisted_16 = { class: "col-span-4 lg:col-span-2 xl:col-span-1" }
const _hoisted_17 = {
  key: 1,
  class: "col-span-12 md:col-span-5 lg:col-span-4 xl:col-span-1 flex justify-between items-center xl:block xl:space-y-1"
}
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = {
  key: 0,
  class: "linked-icon w-5 m-auto",
  src: _imports_1,
  alt: "document icon"
}
const _hoisted_20 = {
  key: 0,
  class: "flex gap-x-1 text-sm md:text-xs"
}
const _hoisted_21 = { class: "whitespace-nowrap" }
const _hoisted_22 = {
  key: 1,
  class: "flex gap-x-1 text-sm md:text-xs"
}
const _hoisted_23 = { class: "whitespace-nowrap" }
const _hoisted_24 = {
  key: 2,
  class: "col-span-4 lg:col-span-3 hidden xl:block xl:col-span-1"
}
const _hoisted_25 = { class: "overflow-hidden" }

import Meeting from './Meeting.vue' // components

	import { // languages
		useI18n
	} from 'vue-i18n'
	
	import { // store
		localesStore
	} from '@/store/locales'
	import { 
		store as _userStore
	} from '@/store/user'

	import { // vue
		computed,
		ref
	} from 'vue'

	
	const __default__ = { name: 'JobCard' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: { 
		job: {
			type: Object,
			default: () => {return {}}
		},
		related: {
			type: Boolean,
			default: false
		},
		hideLine: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const store = localesStore()
	const userStore = _userStore()
	
	const {t} = useI18n()

	const relatedExpanded = ref<boolean>(true)

	const isClient = ref(userStore.getContactType === 'Client')

	const daysLeftToCutoff = computed(() => {
		return daysBetween(props.job.song_cutoff_date) 
	})

	const daysBeforeJobDate = computed(() => {
		return daysBetween(props.job.date_start) 
	})

	const songSelectionBadgeColor = computed(() => {
		if(props.job.all_songs_selected == 1) return 'green'
		else if(daysLeftToCutoff.value > 0) return 'yellow'
		return 'red'
	})

	const songSelectionCompleted = computed(() => {
		if(props.job.all_songs_selected && props.job.song_selection_submitted) return true
		return false
	})

	function daysBetween(date: string) {
		const today = new Date()
		const inputDate = new Date(date)

		const timeDifference = inputDate.getTime() - today.getTime()
		const daysDifference = Math.round(timeDifference / (1000 * 60 * 60 * 24)) + 1

		return daysDifference
	}

return (_ctx: any,_cache: any) => {
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_data_display = _resolveComponent("data-display")!
  const _component_tw_badge_flat = _resolveComponent("tw-badge-flat")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Job = _resolveComponent("Job", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass({'border-l-2 ml-2 sm:ml-4.5 border-gray-300 pt-4': __props.related && !__props.hideLine})
    }, [
      _createVNode(_component_router_link, {
        to: {name: 'JobDetails', params: {recordId: __props.job.recordId}}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["card group hover:bg-gray-50 cursor-pointer relative p-4", {
					'rounded-br-none': __props.job.relatedMeetings?.length, 
					'rounded-bl-none sm:rounded-bl-md': __props.job.relatedMeetings?.length && __props.related, 
					'ml-4.5 before:pointer-events-none before:absolute before:left-0 before:-ml-7 before:top-1/2 before:-translate-y-1/2 before:h-4 before:w-4 before:rounded-full before:bg-white before:border-gray-400 before:border-2': __props.related && !__props.hideLine}])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex justify-start items-center gap-2", [__props.related ? 'text-indigo-500 fill-indigo-500 group-hover:fill-indigo-600 group-hover:text-indigo-600' : 'text-brand-500 fill-brand-500 group-hover:fill-brand-600 group-hover:text-brand-600']])
                }, [
                  _createElementVNode("img", {
                    class: _normalizeClass([__props.related ? 'grayed-icon' : 'linked-icon', 'h-6 w-6']),
                    src: _imports_0,
                    alt: "jobs icon"
                  }, null, 2),
                  _createElementVNode("h2", {
                    class: "text-lg truncate",
                    title: __props.job.name
                  }, _toDisplayString(__props.job.name ?? __props.job['job__JOBS__jobID::name_bride_groom_display']), 9, _hoisted_3)
                ], 2),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, [
                    _createTextVNode(_toDisplayString(__props.job.date_start ?? __props.job['job__JOBS__jobID::date_start']) + " ", 1),
                    _hoisted_6
                  ]),
                  _createElementVNode("p", _hoisted_7, [
                    _createTextVNode(_toDisplayString(__props.job.type_display ?? __props.job['job__JOBS__jobID::type_display']) + " ", 1),
                    _hoisted_8
                  ]),
                  _createElementVNode("p", _hoisted_9, " ID: " + _toDisplayString(__props.job.job_id ?? __props.job.recordId), 1)
                ]),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('jobsList.plannerFilter')) + ": " + _toDisplayString(__props.job.planner_name ?? __props.job['job__job__CONTACTS__plannerID::name_display']), 1)
              ]),
              (__props.job?.relatedJobs?.length || __props.job?.relatedMeetings?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("button", {
                      class: "absolute top-0 right-0 p-4 -mt-4 -mr-4",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (relatedExpanded.value = !relatedExpanded.value), ["prevent"]))
                    }, [
                      _createVNode(_component_ChevronDownIcon, {
                        class: _normalizeClass(["w-5 h-5 transition-all ease-in-out", {'-rotate-90': !relatedExpanded.value}])
                      }, null, 8, ["class"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_data_display, {
                  label: _unref(store).getLabel('11'),
                  "label-class": _unref(store).locales.selected == 'kana' ? 'text-xs' : '',
                  value: (__props.job.category_display ?? __props.job['job__JOBS__jobID::category_display']) || '—'
                }, null, 8, ["label", "label-class", "value"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_data_display, {
                  label: _unref(store).getLabel('173'),
                  "label-class": _unref(store).locales.selected == 'kana' ? 'text-xs' : '',
                  value: (__props.job.service ?? __props.job['job__jobs__CONTACTS_SERVICES__contactServicesID::name_display']) || '—'
                }, null, 8, ["label", "label-class", "value"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_data_display, {
                  label: _unref(store).getLabel('129'),
                  "label-class": _unref(store).locales.selected == 'kana' ? 'text-xs' : '',
                  value: __props.job.style_name_display_override || __props.job.style_name_display || __props.job['job__jobs__contact_service__STYLE__styleID::name_display'] || __props.job['jobs__jobs__contacts_services__services__STYLES__stylesID:name_display'] || '—'
                }, null, 8, ["label", "label-class", "value"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_data_display, {
                  label: _unref(store).getLabel('130'),
                  "label-class": _unref(store).locales.selected == 'kana' ? 'text-xs' : '',
                  value: __props.job.theme_name_display_override || __props.job.theme_name_display || __props.job['job__jobs__contact_service__THEMES__themeID::name_display'] || __props.job['jobs__jobs__contacts_services__services__THEMES__themesID::name_display'] || '—'
                }, null, 8, ["label", "label-class", "value"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_data_display, {
                  label: _unref(store).getLabel('144'),
                  "label-class": _unref(store).locales.selected == 'kana' ? 'text-xs' : '',
                  value: _ctx.$filters.hour24Time(__props.job.time_start || __props.job['job__JOBS__jobID::time_start'])
                }, null, 8, ["label", "label-class", "value"])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass([__props.job.is_wedding && isClient.value && daysBeforeJobDate.value >= 0 ? 'xl:col-span-1' : 'xl:col-span-2', "col-span-4 lg:col-span-2"])
              }, [
                _createVNode(_component_data_display, {
                  label: _unref(store).getLabel('322'),
                  "label-class": _unref(store).locales.selected == 'kana' ? 'text-xs' : '',
                  value: _ctx.$filters.hour24Time(__props.job.time_end || __props.job['job__JOBS__jobID::time_end'])
                }, null, 8, ["label", "label-class", "value"])
              ], 2),
              (__props.job.is_wedding && isClient.value && daysBeforeJobDate.value >= 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      (__props.job.song_selection_submitted == 1)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                        : _createCommentVNode("", true),
                      _createVNode(_component_tw_badge_flat, {
                        class: "whitespace-nowrap",
                        color: songSelectionBadgeColor.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.job.all_songs_selected == 1 ? _unref(t)('jobsList.allSongsSelected') : _unref(t)('jobsList.missingSongs')), 1)
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ]),
                    (!songSelectionCompleted.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("span", _hoisted_21, _toDisplayString(daysLeftToCutoff.value > 0 ? _unref(t)('jobsList.daysLeft') : _unref(t)('jobsList.daysOverdue')) + ":", 1),
                          _createElementVNode("span", null, _toDisplayString(Math.abs(daysLeftToCutoff.value)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!songSelectionCompleted.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(t)('jobsList.cutoff')) + ":", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatDate(__props.job.song_cutoff_date || __props.job['job__JOBS__jobID::song_cutoff_date'])), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (__props.job?.relatedJobs?.length || __props.job?.relatedMeetings?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("button", {
                      class: "float-right h-full px-4 -mr-4",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (relatedExpanded.value = !relatedExpanded.value), ["prevent"]))
                    }, [
                      _createVNode(_component_ChevronDownIcon, {
                        class: _normalizeClass(["w-5 h-5 transition-all ease-in-out", {'-rotate-90': !relatedExpanded.value}])
                      }, null, 8, ["class"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ]),
        _: 1
      }, 8, ["to"])
    ], 2),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", {
        class: _normalizeClass(["transition-all duration-500 ease-in-out", {'-mt-1000%': !relatedExpanded.value, 'mt-0': relatedExpanded.value}])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.job.relatedMeetings, (meeting, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, [
            _createElementVNode("div", {
              class: _normalizeClass({'border-l-2 ml-2 sm:ml-4.5 border-gray-300': __props.job?.relatedJobs?.length})
            }, [
              _createVNode(Meeting, {
                meeting: meeting,
                class: _normalizeClass(["rounded-t-none", {'rounded-b-none': i < __props.job.relatedMeetings.length - 1, 'ml-4.5 sm:ml-13.5': __props.job?.relatedJobs?.length, 'ml-7 sm:ml-20': !__props.job?.relatedJobs?.length}])
              }, null, 8, ["meeting", "class"])
            ], 2)
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.job.relatedJobs, (relatedJob, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, [
            _createVNode(_component_Job, {
              job: relatedJob,
              related: ""
            }, null, 8, ["job"])
          ]))
        }), 128))
      ], 2)
    ])
  ], 64))
}
}

})